export default __webpack_public_path__ + "static/media/firewall.2d6048fe.png";